import {MessageCodes} from "../MessageCodes";
import ResultTable from "../../Table/ResultTable";
import ResultText from "../ResultText";
import {useUser} from "../../../Context/UserContext";
import EmptyLine from "../../EmptyLine";
import ResultHeader from "../../Table/ResultHeader";
import ResultRow from "../../Table/ResultRow";
import ResultHeaderCell from "../../Table/ResultHeaderCell";
import HecRasHelper from "../../../Helpers/HecRasHelper";
import ResultBody from "../../Table/ResultBody";
import ResultBodyCell from "../../Table/ResultBodyCell";
import ResultView from "../../V2/ResultView";
import CheckCSName from "../../CheckCSName";

export function XS5({data, message_key}) {
    const {settings} = useUser()

    return (
        <>
            {
                data?.result?.map(row => (
                    <ResultView error_id={row?.error_id} message_key={message_key}>
                        <Description row={row} settings={settings} globalVariables={data?.global_variables} />
                    </ResultView>
                ))
            }
        </>
    )
}

const Description = ({text, row, settings, globalVariables}) => {
    switch (row.error_id) {
        case MessageCodes.Internal.XS5_XS05.error_id: {
            return (
                <>
                    <ResultText>
                        The invert slope is less than the threshold value of {settings?.thresholds?.inv_slope_threshold?.toFixed(3)} at the following {row?.data?.length} cross sections.
                    </ResultText>
                    <EmptyLine />
                    <ResultTable data={row}>
                        <ResultHeader>
                            <ResultRow>
                                <ResultHeaderCell style={{textAlign: 'start', width: HecRasHelper.getWidth(15)}}>River Station</ResultHeaderCell>
                                <ResultHeaderCell style={{textAlign: 'end', width: HecRasHelper.getWidth(12)}}>DSRL (ft)</ResultHeaderCell>
                                <ResultHeaderCell style={{textAlign: 'end', width: HecRasHelper.getWidth(12)}}>Elev Diff (ft)</ResultHeaderCell>
                                <ResultHeaderCell style={{textAlign: 'end', width: HecRasHelper.getWidth(12)}}>Invert Slope</ResultHeaderCell>
                            </ResultRow>
                        </ResultHeader>
                        <ResultBody>
                            {
                                row?.data?.map(r => (
                                    <ResultRow>
                                        <ResultBodyCell style={{textAlign: 'start', width: HecRasHelper.getWidth(15)}}>
                                            <CheckCSName csName={r?.cross_section} />
                                        </ResultBodyCell>
                                        <ResultBodyCell style={{textAlign: 'end', width: HecRasHelper.getWidth(12)}}>{r?.dsrl}</ResultBodyCell>
                                        <ResultBodyCell style={{textAlign: 'end', width: HecRasHelper.getWidth(12)}}>{r?.elev_diff}</ResultBodyCell>
                                        <ResultBodyCell style={{textAlign: 'end', width: HecRasHelper.getWidth(12)}}>{r?.slope}</ResultBodyCell>
                                    </ResultRow>
                                ))
                            }
                        </ResultBody>
                    </ResultTable>
                </>
            )
        }
        case MessageCodes.Internal.XS5_XS09.error_id: {
            const max = Math.max(...row?.data?.map(r => parseFloat(r?.elev_diff)))
            return (
                <>
                    <ResultText>
                        The invert slope is more than the threshold value of {settings?.thresholds?.inv_slope_threshold_max?.toFixed(3)} at the following {row?.data?.length} cross sections.
                    </ResultText>
                    <EmptyLine />
                    <ResultTable data={row}>
                        <ResultHeader>
                            <ResultRow>
                                <ResultHeaderCell style={{textAlign: 'start', width: HecRasHelper.getWidth(15)}}>River Station</ResultHeaderCell>
                                <ResultHeaderCell style={{textAlign: 'end', width: HecRasHelper.getWidth(12)}}>DSRL (ft)</ResultHeaderCell>
                                <ResultHeaderCell style={{textAlign: 'end', width: HecRasHelper.getWidth(12)}}>Elev Diff (ft)</ResultHeaderCell>
                                <ResultHeaderCell style={{textAlign: 'end', width: HecRasHelper.getWidth(12)}}>Invert Slope</ResultHeaderCell>
                            </ResultRow>
                        </ResultHeader>
                        <ResultBody>
                            {
                                row?.data?.map(r => (
                                    <ResultRow>
                                        <ResultBodyCell style={{textAlign: 'start', width: HecRasHelper.getWidth(15)}}>
                                            <CheckCSName csName={r?.cross_section} />
                                        </ResultBodyCell>
                                        <ResultBodyCell style={{textAlign: 'end', width: HecRasHelper.getWidth(12)}}>{r?.dsrl}</ResultBodyCell>
                                        <ResultBodyCell style={{textAlign: 'end', width: HecRasHelper.getWidth(12), color: max === parseFloat(r?.elev_diff) ? 'red': ''}}>{r?.elev_diff}</ResultBodyCell>
                                        <ResultBodyCell style={{textAlign: 'end', width: HecRasHelper.getWidth(12)}}>{r?.slope}</ResultBodyCell>
                                    </ResultRow>
                                ))
                            }
                        </ResultBody>
                    </ResultTable>
                </>
            )
        }
        default: {
            return `Error Key Not Found: ${row.error_id}`
        }
    }
}